<div class="settings-page">
    <settings-menu></settings-menu>
</div>